<template>
  <div class="container-fluid">
    <div class="row">
      <div
        id="privacy-wrapper"
        class="col-sm-12 col-md-10 col-lg-6 offset-md-1 offset-lg-3 wrapper"
      >
        <div
          v-if="
            (!userData || userData?.user?.launchType !== 'lti') &&
            showBackButton
          "
        >
          <back-button />
        </div>
        <div class="d-flex flex-column main-content" tabindex="-1">
          <h1 class="heading1 align-self-center">
            {{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE') }}
          </h1>
          <p class="description">
            {{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_1.PART_1') }}
            <strong>{{
              $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_1.STRONG_TEXT')
            }}</strong>
            <span>{{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_1.PART_2') }}</span>
          </p>
          <p class="description">
            {{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_0')
            }}<!--Make sure handleFirstLinkKeydown handler stays on first link/button of this modal-->
            <NuxtLink
              v-if="!isielts"
              to="/terms"
              target="_blank"
              qid="privacy-1"
              @keydown="handleFirstLinkKeydown($event)"
              >{{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_1') }}</NuxtLink
            ><NuxtLink
              v-if="isielts"
              to="/terms?ielts=true"
              target="_blank"
              qid="privacy-9"
              >{{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_1') }}</NuxtLink
            >{{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_2') }}
            <NuxtLink to="/home" target="_blank" qid="privacy-2">{{
              url
            }}</NuxtLink>
            <span>
              {{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_4.PART_1') }}
              <strong>{{
                $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_4.STRONG_TEXT')
              }}</strong>
              {{ $t('ONBOARDING.PRIVACY.PRIVACY_NOTICE_2_4.PART_2') }}
            </span>
          </p>
          <ol class="numberList">
            <li>
              <h2 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.IMPORTANT_INFORMATION_HEADING') }}
              </h2>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.CONTROLLER') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CONTROLLER_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CONTROLLER_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CONTROLLER_DESCRIPTION_3') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.CONTACT_DETAILS') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CONTACT_DETAILS_DESCRIPTION') }}
                <a href="mailto:privacy@cambridge.org" qid="privacy-3">{{
                  'privacy@cambridge.org'
                }}</a>
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.CHANGES') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CHANGES_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.CHANGES_DESCRIPTION_2') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.THIRD_PARTY') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.THIRD_PARTY_DESCRIPTION') }}
              </p>
            </li>
            <li>
              <h2 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.DATA_HEADING') }}
              </h2>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_2_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_3') }}
              </p>
              <ul class="bulletList">
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_4.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_4.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_5.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_5.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_6.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_6.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_7.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_7.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_8.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_8.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_9.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_9.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_10.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_10.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_11.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_11.PART_1') }}
                </li>
                <li class="description">
                  <strong>{{
                    $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_12.STRONG_TEXT')
                  }}</strong>
                  {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_12.PART_1') }}
                </li>
              </ul>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_13.PART_1') }}
                <strong>{{
                  $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_13.STRONG_TEXT')
                }}</strong>
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_13.PART_2') }}
                <strong>{{
                  $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_13.STRONG_TEXT_2')
                }}</strong>
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_13.PART_3') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_14.PART_1') }}
                <strong>{{
                  $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_14.STRONG_TEXT')
                }}</strong>
                {{ $t('ONBOARDING.PRIVACY.DATA_DESCRIPTION_14.PART_2') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.DATA_FAIL') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DATA_FAIL_DESCRIPTION') }}
              </p>
            </li>
            <li>
              <h2 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_HEADING') }}
              </h2>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_1') }}
              </p>
              <ul class="bulletList">
                <li>
                  <p class="description">
                    <strong>{{
                      $t(
                        'ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_0.STRONG_TEXT'
                      )
                    }}</strong>
                    {{
                      $t(
                        'ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_0.PART_1'
                      )
                    }}
                  </p>
                  <ul class="bulletList">
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_1') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_2') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_3') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_4') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_5') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_6') }}
                    </li>
                    <li class="description">
                      {{ $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_2_7') }}
                    </li>
                  </ul>
                </li>
                <li class="description">
                  <strong>{{
                    $t(
                      'ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_3.STRONG_TEXT'
                    )
                  }}</strong>
                  {{
                    $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_3.PART_1')
                  }}
                </li>
                <li class="description">
                  <strong>{{
                    $t(
                      'ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_4.STRONG_TEXT'
                    )
                  }}</strong>
                  {{
                    $t('ONBOARDING.PRIVACY.HOW_COLLECT_DESCRIPTION_4.PART_1')
                  }}
                </li>
              </ul>
            </li>
            <li>
              <h2 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.HOW_USE_HEADING') }}
              </h2>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_1') }}
              </p>
              <ul class="bulletList">
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_2') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_3') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_4') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_5') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.HOW_USE_DESCRIPTION_6') }}
                </li>
              </ul>
              <h3 id="purposeTableHeading" class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.PURPOSE_TABLE_HEADING') }}
              </h3>
              <div class="table-container mb-1">
                <div class="table-inner-container">
                  <div class="table-cell-container">
                    <table aria-describedby="purposeTableHeading">
                      <tr>
                        <th class="sub-heading">
                          {{ $t('ONBOARDING.PRIVACY.COLUMN_HEADING_1') }}
                        </th>
                        <th class="sub-heading">
                          {{ $t('ONBOARDING.PRIVACY.COLUMN_HEADING_2') }}
                        </th>
                        <th class="sub-heading">
                          {{ $t('ONBOARDING.PRIVACY.COLUMN_HEADING_3') }}
                        </th>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_1') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_1_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_1_1') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_1_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_1_1') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="description">
                            {{ $t('ONBOARDING.PRIVACY.PURPOSE_2_0') }}
                          </p>
                          <ul class="bulletList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.PURPOSE_2_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.PURPOSE_2_2') }}
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_2_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_2_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_2_2') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_2_3') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_2_4') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_2_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_2_1') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="description">
                            {{ $t('ONBOARDING.PRIVACY.PURPOSE_3_0') }}
                          </p>
                          <ul class="bulletList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.PURPOSE_3_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.PURPOSE_3_2') }}
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_3_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_3_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_3_2') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_3_3') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_3_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_3_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_3_2') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_4') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_4_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_4_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_4_2') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_4_3') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_4_4') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_4_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_4_1') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_5') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_5_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_5_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_5_2') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_5_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_5_1') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_6') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_2') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_3') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_4') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_5') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_6') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_6') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_9') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_9') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_9_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_9_1') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_7') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_7_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_7_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_7_2') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_7') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td class="description">
                          {{ $t('ONBOARDING.PRIVACY.PURPOSE_8') }}
                        </td>
                        <td>
                          <ol class="alphabeticList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_8_0') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_8_1') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_6_2') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_8_3') }}
                            </li>
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.TYPE_8_4') }}
                            </li>
                          </ol>
                        </td>
                        <td>
                          <ol class="romanList">
                            <li class="description">
                              {{ $t('ONBOARDING.PRIVACY.LAWFUL_8') }}
                            </li>
                          </ol>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.MARKETING_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.MARKETING_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.MARKETING_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.MARKETING_DESCRIPTION_3') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.OPTING_OUT_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.OPTING_OUT_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.OPTING_OUT_DESCRIPTION_2') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_3') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_4') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_5') }}
              </p>
              <p class="description">
                <strong>{{
                  $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_6.STRONG_TEXT')
                }}</strong
                >{{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_6.PART_1') }}
              </p>
              <p class="description">
                <strong>{{
                  $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_7.STRONG_TEXT')
                }}</strong
                >{{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_7.PART_1') }}
              </p>
              <p class="description">
                <strong>{{
                  $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_8.STRONG_TEXT')
                }}</strong
                >{{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_8.PART_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_9') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_10_0')
                }}<a
                  href="https://www.hotjar.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  qid="privacy-7"
                  >{{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_10_1') }}</a
                >
                {{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_10_2')
                }}<a
                  href="https://www.hotjar.com/legal/compliance/opt-out"
                  rel="noopener noreferrer"
                  target="_blank"
                  qid="privacy-8"
                  >{{ $t('ONBOARDING.PRIVACY.COOKIES_DESCRIPTION_10_3') }}</a
                >
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.PURPOSE_CHANGE_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.PURPOSE_CHANGE_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.PURPOSE_CHANGE_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.PURPOSE_CHANGE_DESCRIPTION_3') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_3') }}
              </p>
              <ul class="bulletList">
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_4') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_5') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_6') }}
                </li>
              </ul>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_7') }}
              </p>
              <ul class="bulletList">
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_8') }}
                </li>
                <li class="description">
                  {{ $t('ONBOARDING.PRIVACY.DISCLOSURES_DESCRIPTION_9') }}
                </li>
              </ul>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.INTERNATION_TRANS_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.INTERNATION_DESCRIPTION_1.PART_1')
                }}<strong>{{
                  $t('ONBOARDING.PRIVACY.INTERNATION_DESCRIPTION_1.STRONG_TEXT')
                }}</strong
                >{{ $t('ONBOARDING.PRIVACY.INTERNATION_DESCRIPTION_1.PART_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.INTERNATION_DESCRIPTION_2') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.SECURITY_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.SECURITY_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.SECURITY_DESCRIPTION_2') }}
              </p>
              <h3 class="sub-sub-heading">
                {{ $t('ONBOARDING.PRIVACY.RETENTION_HEADING_1') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.RETENTION_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.RETENTION_DESCRIPTION_2') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.LEGAL_HEADING_1') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.LEGAL_DESCRIPTION_1') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.LEGAL_DESCRIPTION_2') }}
              </p>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.LEGAL_DESCRIPTION_3')
                }}<a href="mailto:privacy@cambridge.org" qid="privacy-4">{{
                  'privacy@cambridge.org'
                }}</a
                >{{ $t('_COMMON_ACROSS_MODULES.PERIOD') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.FEE_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.FEE_DESCRIPTION') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.WHAT_NEED_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.WHAT_NEED_DESCRIPTION') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.TIME_LIMIT_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.TIME_LIMIT_DESCRIPTION') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.OFFICER_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.OFFICER_DESCRIPTION_0')
                }}<a href="mailto:dpo@admin.cam.ac.uk" qid="privacy-6">{{
                  'dpo@admin.cam.ac.uk'
                }}</a
                >{{ $t('ONBOARDING.PRIVACY.OFFICER_DESCRIPTION_1') }}
              </p>
              <h3 class="sub-heading">
                {{ $t('ONBOARDING.PRIVACY.COMPLAINTS_HEADING') }}
              </h3>
              <p class="description">
                {{ $t('ONBOARDING.PRIVACY.COMPLAINTS_DESCRIPTION_0')
                }}<a
                  href="https://ico.org.uk/"
                  target="_blank"
                  qid="privacy-5"
                  rel="noopener noreferrer"
                  >{{ $t('ONBOARDING.PRIVACY.COMPLAINTS_DESCRIPTION_1') }}</a
                >{{ $t('ONBOARDING.PRIVACY.COMPLAINTS_DESCRIPTION_2') }}
              </p>
            </li>
          </ol>
          <p class="last-updated">
            {{ $t('ONBOARDING.PRIVACY.LAST_UPDATED') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { hideLoader } = useLoaderService();
const route = useRoute();
const url = ref(),
  userData = ref(),
  isielts = ref(false);

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: false
  }
});

// handle keydown event for modal
const handleFirstLinkKeydown = (event) => {
  if (event.shiftKey && event.key === 'Tab') {
    const closeButton = document.getElementById('closeModalbtn');
    if (closeButton) {
      event.preventDefault();
      closeButton.focus();
    }
  }
};
onBeforeMount(async () => {
  // get relative url for links
  url.value = window.location.protocol + '//' + window.location.host;
  // check if ielts true
  isielts.value = route.query.ielts;
  const { isUserAuthenticated } = useAuthService();
  userData.value = await isUserAuthenticated();
});
onMounted(() => {
  hideLoader();
  document.body.focus();
});
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 34px;
  h1,
  ol,
  li {
    color: var(--cup-general-color-5);
  }
  a {
    color: #8a4ed1;
  }
  h2 {
    font-size: 18px;
  }
  th,
  h3 {
    font-size: 16px;
  }
  .main-content:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
  .description {
    padding-bottom: 7px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    @include media-breakpoint-up(sm) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .sub-heading {
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 17px;
  }
  .sub-sub-heading {
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 17px;
  }
  ol {
    counter-reset: item;
    display: table;
    padding-left: 0px;
    > li {
      display: table-row;
      list-style: none;
      &:before {
        counter-increment: item;
        display: table-cell;
        text-align: right;
        padding-right: 8px;
      }
    }
    &.numberList {
      > li:before {
        content: counters(item, '.') '.';
        font-size: 18px;
        font-weight: 800;
        line-height: 24px;
      }
    }
    &.romanList {
      > li:before {
        content: '(' counter(item, lower-roman) ') ';
      }
    }
    &.alphabeticList {
      > li:before {
        content: '(' counter(item, lower-alpha) ') ';
      }
    }
  }
  ul {
    list-style: none;
    &.bulletList {
      list-style-type: disc;
      > li {
        display: list-item;
      }
    }
  }
  .table-container {
    width: calc(100% - 30px);
    overflow-x: auto;
    .table-inner-container {
      display: table;
      table-layout: fixed;
      width: 100%;
      .table-cell-container {
        display: table-cell;
        width: 100%;
        table {
          border: 1px solid var(--cup-general-color-3);
          width: 100%;
          border-collapse: collapse;
          th {
            text-align: center;
            padding: 15px;
            border: 1px solid var(--cup-general-color-3);
          }
          td {
            vertical-align: top;
            padding: 10px;
            border: 1px solid var(--cup-general-color-3);
          }
        }
      }
    }
  }
  .last-updated {
    color: var(--cup-general-color-4);
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }
}

.modal-body #privacy-wrapper {
  padding: 16px;
  margin: 0;
  max-width: 100%;
  flex: 0 0 100%;
  overflow-x: hidden;
  a {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.5px;
    line-height: 14px;
    cursor: pointer;
  }
  .heading1 {
    display: none;
  }
  .table-container {
    max-height: 308px;
    width: 100%;
    overflow: auto;
    .table-inner-container {
      display: table;
      table-layout: fixed;
      width: 100%;
      .table-cell-container {
        display: table-cell;
        width: 100%;
        table {
          border: 1px solid var(--cup-general-color-3);
          width: 100%;
          border-collapse: collapse;
          th {
            text-align: center;
            padding: 15px;
            border: 1px solid var(--cup-general-color-3);
          }
          td {
            vertical-align: top;
            padding: 10px;
            border: 1px solid var(--cup-general-color-3);
          }
        }
      }
    }
  }
}
</style>
